import React, { useState } from 'react';

import * as S from './styles';
import { DataFormProps, BannerProps } from 'types/InputsGridOfBannersProps';
import FormAddBannerInGrid from 'components/FormAddBannerInGrid';
import DoubleBanner from './Grids/DoubleBanner';
import TripleBanner from './Grids/TripleBanner';
import TripleBannerLeft from './Grids/TripleBannerLeft';
import TripleBannerRigth from './Grids/TripleBannerRigth';
import DoubleBannerVertical from './Grids/DoubleBannerVertical';
import MosaicoBanner from './Grids/MosaicoBanner';
import MosaicoBannerTriple from './Grids/MosaicoBannerTriple';
import { getImageDimensions } from 'utils/functions';

interface AddBannerInGridProps {
	dataForm: DataFormProps;
	setDataForm: React.Dispatch<React.SetStateAction<DataFormProps>>;
	isShow: boolean;
}

export default function AddBannerInGrid({
	isShow,
	dataForm,
	setDataForm
}: AddBannerInGridProps) {
	const [isFormBannerOpen, setIsFormBannerOpen] = useState(false);
	const [bannerToEdit, setBannerToEdit] = useState<BannerProps | null>(null);

	function deleteBanner(id: string | number) {
		const newList = dataForm.banners.filter((item) => item.id !== id);

		setDataForm((obj) => ({ ...obj, banners: newList }));
	}

	function saveBanner(newBanner: BannerProps) {
		getImageDimensions(newBanner.file_path).then(({ height, width }) => {
			newBanner.bannerDimenssions.height = height;
			newBanner.bannerDimenssions.width = width;
		});

		setDataForm((obj) => ({ ...obj, banners: [...obj.banners, newBanner] }));
		setIsFormBannerOpen(false);
		setBannerToEdit(null);
	}

	function editBanner(bannerEdited: BannerProps) {
		getImageDimensions(bannerEdited.file_path).then(({ height, width }) => {
			bannerEdited.bannerDimenssions.height = height;
			bannerEdited.bannerDimenssions.width = width;
		});

		const newList = dataForm.banners.map((item) => {
			if (item.id === bannerToEdit?.id) {
				return bannerEdited;
			}

			return item;
		});

		setDataForm((obj) => ({ ...obj, banners: newList }));
		setIsFormBannerOpen(false);
		setBannerToEdit(null);
	}

	function startToEditBanner(bannerEdited: BannerProps) {
		setIsFormBannerOpen(true);
		setBannerToEdit(bannerEdited);
	}

	function returnGrid(typeGrid: number) {
		switch (typeGrid) {
			case 0:
				return (
					<DoubleBanner
						dataForm={dataForm}
						setDataForm={setDataForm}
						setIsFormBannerOpen={setIsFormBannerOpen}
						deleteBanner={deleteBanner}
						bannerEditedFunction={startToEditBanner}
					/>
				);
			case 1:
				return (
					<TripleBanner
						dataForm={dataForm}
						setDataForm={setDataForm}
						setIsFormBannerOpen={setIsFormBannerOpen}
						deleteBanner={deleteBanner}
						bannerEditedFunction={startToEditBanner}
					/>
				);
			case 2:
				return (
					<TripleBannerLeft
						dataForm={dataForm}
						setDataForm={setDataForm}
						setIsFormBannerOpen={setIsFormBannerOpen}
						deleteBanner={deleteBanner}
						bannerEditedFunction={startToEditBanner}
					/>
				);
			case 3:
				return (
					<TripleBannerRigth
						dataForm={dataForm}
						setDataForm={setDataForm}
						setIsFormBannerOpen={setIsFormBannerOpen}
						deleteBanner={deleteBanner}
						bannerEditedFunction={startToEditBanner}
					/>
				);
			case 4:
				return (
					<DoubleBannerVertical
						dataForm={dataForm}
						setDataForm={setDataForm}
						setIsFormBannerOpen={setIsFormBannerOpen}
						deleteBanner={deleteBanner}
						bannerEditedFunction={startToEditBanner}
					/>
				);
			case 5:
				return (
					<MosaicoBanner
						dataForm={dataForm}
						setDataForm={setDataForm}
						setIsFormBannerOpen={setIsFormBannerOpen}
						deleteBanner={deleteBanner}
						bannerEditedFunction={startToEditBanner}
					/>
				);
			case 6:
				return (
					<MosaicoBannerTriple
						dataForm={dataForm}
						setDataForm={setDataForm}
						setIsFormBannerOpen={setIsFormBannerOpen}
						deleteBanner={deleteBanner}
						bannerEditedFunction={startToEditBanner}
					/>
				);

			default:
				return <p>Grid não esperado</p>;
		}
	}

	return (
		<S.container $isShow={isShow}>
			<S.boxGrids>{returnGrid(dataForm.typeGridBanners)}</S.boxGrids>

			{isFormBannerOpen && (
				<FormAddBannerInGrid
					functionToSave={bannerToEdit === null ? saveBanner : editBanner}
					bannerToEdit={bannerToEdit}
					setBannerToEdit={setBannerToEdit}
					isFormBannerOpen={isFormBannerOpen}
					setIsFormBannerOpen={setIsFormBannerOpen}
				/>
			)}
		</S.container>
	);
}
